import { useMemo } from "react";

import { Bank, CreditOptionsResponse } from "types";

import { ContractPaymentStructure } from "../../bank-selection/components/contract-payment-structure";
import { ContractDetails } from "../../bank-selection/hooks/types";
import { useContractPayments } from "../../bank-selection/hooks/use-contract-payments";

interface CreditContractPaymentStructureProps {
  options: CreditOptionsResponse;
  contract: ContractDetails;
}

// "Struktura iznosa" of the approved bank's contract, shared with "O kreditu"
const CreditContractPaymentStructure = ({ options, contract }: CreditContractPaymentStructureProps) => {
  const {
    contractPayments,
    contractPaymentTypes,
    isAddingContractPayment,
    newContractPaymentType,
    newContractPaymentBank,
    newContractPaymentContractNumber,
    newContractPaymentAmount,
    isCreatingContractPayment,
    contractPaymentsTotalAmount,
    setIsAddingContractPayment,
    setNewContractPaymentType,
    setNewContractPaymentBank,
    setNewContractPaymentContractNumber,
    setNewContractPaymentAmount,
    handleCreateContractPayment,
    handleDeleteContractPayment,
    resetNewContractPaymentForm,
    isDeletingPayment,
  } = useContractPayments(contract.id);

  const availableBanks = useMemo(
    () => Array.from(new Set(Object.values(options?.structureTypeBanks ?? {}).flat())) as Bank[],
    [options],
  );

  const hasAmountMismatch =
    contractPaymentsTotalAmount > 0 &&
    (contract.creditAmount ?? 0) > 0 &&
    contractPaymentsTotalAmount !== contract.creditAmount;

  return (
    <ContractPaymentStructure
      contractId={contract.id}
      creditAmount={contract.creditAmount}
      contractPayments={contractPayments}
      contractPaymentTypes={contractPaymentTypes}
      availableBanks={availableBanks}
      hasAmountMismatch={hasAmountMismatch}
      isAddingContractPayment={isAddingContractPayment}
      newContractPaymentType={newContractPaymentType}
      newContractPaymentBank={newContractPaymentBank}
      newContractPaymentContractNumber={newContractPaymentContractNumber}
      newContractPaymentAmount={newContractPaymentAmount}
      isCreatingContractPayment={isCreatingContractPayment}
      onAddContractPayment={() => setIsAddingContractPayment(true)}
      onNewContractPaymentTypeChange={setNewContractPaymentType}
      onNewContractPaymentBankChange={setNewContractPaymentBank}
      onNewContractPaymentContractNumberChange={setNewContractPaymentContractNumber}
      onNewContractPaymentAmountChange={setNewContractPaymentAmount}
      onCreateContractPayment={handleCreateContractPayment}
      onDeleteContractPayment={handleDeleteContractPayment}
      onResetNewContractPaymentForm={resetNewContractPaymentForm}
      isDeletingPayment={isDeletingPayment}
    />
  );
};

export default CreditContractPaymentStructure;
